import script from "./PageTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageTabs.vue?vue&type=script&lang=ts&setup=true"

import "./PageTabs.vue?vue&type=style&index=0&id=20d8376c&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d8376c"]])

export default __exports__